(function () {

  'use strict';

  angular.module('eclipseApp.components')

    .directive('uteHeader', ['$rootScope', '$http', '$compile', 'uteEndpoint', 'commonService', '$state', 'uteLocale', 'env', '$window', 'permissionsService', function ($rootScope, $http, $compile, uteEndpoint, commonService, $state, uteLocale, env, $window, permissionsService) {

      return {
        restrict: 'AE',
        scope: true,
        replace: false,
        link: function ($scope, $element, $attrs) {

          $scope.internetNotificationsCount = 0;

          $scope.commonService = commonService;

          $scope.showServiceDropdownIcon = false;

          $scope.billingPaymentsLink = {};
          permissionsService.getPreferences();
          $scope.isMobileServiceActive = false;
          $scope.wirelessSubscriberNo = commonService.wirelessSubscriberNo;
          $scope.wirelessAccountNumber = commonService.wirelessAccountNumber;
          $scope.isInternetServiceActive = false;
          $scope.internetSubscriberNo = commonService.internetSubscriberNo;
          $scope.internetAccountNumber = commonService.internetAccountNumber;
          $scope.isTVServiceActive = false;
          $scope.tvSubscriberNo = commonService.tvSubscriberNo;
          $scope.tvAccountNumber = commonService.tvAccountNumber;
          $scope.isFraudTVService = false;
          $scope.isFraudInternetService = false;
          $scope.filterFraudAccount = true;
          $scope.onlyPrepaidAccounts = true;

          $scope.filterWirelessCFA = function(account) {
            return ($rootScope.ruiMethods.user.is.agent() === false || account.serviceName !== 'Wireless');
          };

          $scope.filterFraud = function(accountNumber) {
            var selectedAccountDetail = _.find(commonService.accountDetails, function(accountDetail) {
              return accountDetail.accountNumber === accountNumber;
            });
            return (!selectedAccountDetail || selectedAccountDetail.fraud !== true);
          };

          $scope.filterTentativeAccount = function(account) {
            return (account && account.status !== 'TENTATIVE');
          };

          $scope.getDefaultAccount = function() {
            var accountDefault = false;
            var i = 1;
            _.each($rootScope.userInfo.accounts, function(account) {
              if (account.serviceName == 'Internet/TV') {
                account.serviceNameLabel = "Internet";
              } else {
                account.serviceNameLabel = "Mobile";
              }
              if (i == 1 && account && account.accountNumber && $scope.filterWirelessCFA(account) && $scope.filterTentativeAccount(account)) {
                 accountDefault = account;
                 i = i + 1;
              }
            });
            return accountDefault;
          };

          $scope.getServiceLabel = function(accountNumber){
            var serviceLabel = "";
            _.each($rootScope.userInfo.accounts, function(account) {
              if(account.accountNumber == accountNumber){
                if (account.serviceName == 'Internet/TV') {
                  serviceLabel = "Internet";
                } else {
                  serviceLabel = "Mobile";
                }
              }
            });
            return serviceLabel;
          };

          // Checking & Setting Account Level status - START
          $scope.checkAssociatedServicesStatus = function(accountNumber) {
            var onlyFraudAccounts = true;
            var fraudInternetAccount = false;
            var fraudTVAccount = false;
            var accountDetails = commonService.accountDetails;
            $scope.showServiceDropdownIcon = false;
            $scope.isMobileServiceActive = false;
            $scope.isInternetServiceActive = false;
            $scope.isTVServiceActive = false;

            // Looping through accounts - START
            _.each(accountDetails, function (accountDetail) {
              if(accountDetail.accountNumber === accountNumber){
                $scope.selectedAcctMOPType = accountDetail.MOPType;
                // Mobile Service ACTIVE OR NOT
                if (accountDetail.hasWireless && accountDetail.accountStatus && accountDetail.accountStatus.toUpperCase() !== 'CANCELLED' && accountDetail.accountStatus.toUpperCase() !== 'SUSPENDED') {
                  _.each(accountDetail.subscriberServices, function (subscriberService) {
                    if (subscriberService.wireless) {
                      $scope.isMobileServiceActive = true;
                      $scope.wirelessSubscriberNo = subscriberService.wireless.subscriberNo;
                      $scope.wirelessAccountNumber = accountDetail.accountNumber;
                      $scope.showServiceDropdownIcon = true;
                    }
                  });
                  if(accountDetail.LOB === 'WLPP'){
                    $scope.wirelessPrepaid = true;
                  }else{
                    $scope.wirelessPrepaid = false;
                  }
                }
                // Only Prepaid Accounts
                if (!accountDetail.hasWireless || (accountDetail.hasWireless && accountDetail.LOB !== 'WLPP')) {
                  $scope.onlyPrepaidAccounts = false;
                }else{
                  $scope.onlyPrepaidAccounts = true;
                }

                // Internet/TV Service ACTIVE OR NOT (Includes Fraud Check as well)
                if (accountDetail.hasInternet && accountDetail.accountStatus && accountDetail.accountStatus.toUpperCase() !== 'CANCELLED' && accountDetail.accountStatus.toUpperCase() !== 'SUSPENDED') {
                  if (!accountDetail.fraud) {
                    onlyFraudAccounts = false;
                    _.each(accountDetail.subscriberServices, function (subscriberService) {
                      if (subscriberService.internet) {
                        $scope.isInternetServiceActive = true;
                        $scope.internetSubscriberNo = subscriberService.internet.subscriberNo;
                        $scope.internetAccountNumber = accountDetail.accountNumber;
                        $scope.showServiceDropdownIcon = true;
                      } else if (subscriberService.tv) {
                        $scope.isTVServiceActive = true;
                        $scope.tvSubscriberNo = subscriberService.tv.subscriberNo;
                        $scope.tvAccountNumber = accountDetail.accountNumber;
                        $scope.showServiceDropdownIcon = true;
                      }
                    });
                  } else if (accountDetail.fraud) {
                    _.each(accountDetail.subscriberServices, function (subscriberService) {
                      if (subscriberService.internet) {
                        fraudInternetAccount = true;
                      } else if (subscriberService.tv) {
                        fraudTVAccount = true;
                      }
                    });
                  }
                }
              }
            });
            // Looping through accounts - END

            if (onlyFraudAccounts) {
              $scope.showServiceDropdownIcon = true;
              if (fraudTVAccount && fraudInternetAccount) {
                $scope.isFraudTVService = true;
                $scope.isFraudInternetService = true;
              } else if(fraudTVAccount && !fraudInternetAccount) {
                $scope.isFraudTVService = true;
              } else if(!fraudTVAccount && fraudInternetAccount) {
                $scope.isFraudInternetService = true;
              }
            } else {
              $scope.isFraudTVService = false;
              $scope.isFraudInternetService = false;
            }

          };
          // Checking & Setting Account Level status - END

          //Adding Watch to check selected account value

          $scope.$watch('userInfo.selectedAccountNumber', function (nv, ov) {
            if (nv !== ov) {
              // if accNum changes, update  selectedAccountNumber & other Nav links
              console.log("selected account change" +nv);
              $scope.selectedAccountNumber = nv;
              $scope.selectedServiceLabel = $scope.getServiceLabel($scope.selectedAccountNumber);
              $scope.filterFraudAccount = $scope.filterFraud($scope.selectedAccountNumber);
              $scope.checkAssociatedServicesStatus($scope.selectedAccountNumber);
              $scope.updateBillingPaymentsLink($scope.selectedAccountNumber);
            }
          });
          $scope.$watch(function () {
              return commonService.accountDetails;
            },
            function (newVal) {
              var reloadNotifications = false;
              //Reload notifications only if there is a change in account numbers
              if ($scope.internetSubscriberNo !== commonService.internetSubscriberNo || $scope.internetAccountNumber !== commonService.internetAccountNumber) {
                reloadNotifications = true;
              }

              $scope.accountDetails = newVal;
              $scope.internetSubscriberNo = commonService.internetSubscriberNo;
              $scope.internetAccountNumber = commonService.internetAccountNumber;
              $scope.internetAccountStatus = commonService.internetAccountStatus;
              $scope.tvSubscriberNo = commonService.tvSubscriberNo;
              $scope.tvAccountNumber = commonService.tvAccountNumber;
              $scope.tvAccountStatus = commonService.tvAccountStatus;
              $scope.wirelessSubscriberNo = commonService.wirelessSubscriberNo;
              $scope.wirelessAccountNumber = commonService.wirelessAccountNumber;
              $scope.wirelessAccountStatus = commonService.wirelessAccountStatus;
              $scope.wirelessPrepaid = commonService.wirelessPrepaid;
              $scope.showAccountsDropdown = false;
              $scope.showServices = false;

              //If any service is active then show service dropdown icon otherwise hide it
              if (($scope.internetSubscriberNo && ($scope.internetAccountStatus.toUpperCase() !== 'CANCELLED' && $scope.internetAccountStatus.toUpperCase() !== 'SUSPENDED'))
                || ($scope.tvSubscriberNo && ($scope.tvAccountStatus.toUpperCase() !== 'CANCELLED' && $scope.tvAccountStatus.toUpperCase() !== 'SUSPENDED'))
                || ($scope.wirelessSubscriberNo && ($scope.wirelessAccountStatus.toUpperCase() !== 'CANCELLED' && $scope.wirelessAccountStatus.toUpperCase() !== 'SUSPENDED'))) {
                $scope.showServiceDropdownIcon = true;
              } else {
                $scope.showServiceDropdownIcon = false;
              }

              if ($rootScope.userInfo && ($rootScope.userInfo.accounts || []).length > 0) {
                if($rootScope.userInfo.selectedAccountNumber){
                  $scope.selectedAccountNumber = $rootScope.userInfo.selectedAccountNumber;
                }else {
                  if ($scope.getDefaultAccount().accountNumber) {
                    $scope.accountNumber = $scope.getDefaultAccount();
                    $scope.selectedAccountNumber = $scope.getDefaultAccount().accountNumber;
                    $rootScope.userInfo.selectedAccountNumber = $scope.getDefaultAccount().accountNumber;
                  }
                }
                $scope.selectedServiceLabel = $scope.getServiceLabel($scope.selectedAccountNumber);
                $scope.filterFraudAccount = $scope.filterFraud($scope.selectedAccountNumber);
                console.log('selectedAccountNumber:', +$scope.selectedAccountNumber + "service:" +$scope.selectedServiceLabel);
              }

              $scope.checkAssociatedServicesStatus($scope.selectedAccountNumber);
              $scope.updateBillingPaymentsLink($scope.selectedAccountNumber);

              console.log('$scope.accountDetails', $scope.accountDetails);

              console.log('$scope.billingPaymentsLink', $scope.billingPaymentsLink);

              if (reloadNotifications) {
                //Temporarily disabled the notifications on header for now
                //
                //$scope.internetNotificationsCount = 0;
                //if ($scope.internetSubscriberNo) {
                //  var url = uteEndpoint('v1/productNotificationHistory');
                //  $http.post(url, {
                //    accountNumber: $scope.internetAccountNumber,
                //    subscriptionID: $scope.internetSubscriberNo
                //  }).success(function (data) {
                //    $scope.internetNotificationsCount = data.getUsageNotifications.notification.length;
                //  });
                //}
              }

            }, true);
          if ($attrs.isCms === 'true') {
            var path = $attrs.contentPath + uteLocale.language + '_' + uteLocale.province + '.html',
              markUpUrl = uteEndpoint(path, 'cms');

            $http.get(markUpUrl)

              .success(function (result) {

                $element.html(result);

                $compile($element.contents())($scope);

              }).error(function (data) {

            });

          }

          $scope.redirectTo = function (rpath) {
            if (rpath && rpath === '/consumer/home' && $state.includes('buy')) {
              $rootScope.$broadcast('Events:Exit:Home', { toPath: rpath });
              return;
            }
            $window.location.replace(env.fidoHomePageUrl);

          };

          $scope.close = function(){
            $scope.showNavLinks = false;
            $scope.showAccountSection = false;
          };

        },
        controller: 'uteHeaderCtrl'
      };

    }]);


})();
